<template>
  <div
    v-if="showPopup"
    class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-hidden h-full"
    role="dialog"
    aria-labelledby="activity-check-title"
    aria-describedby="activity-check-desc"
  >
    <div class="bg-white rounded-lg shadow-lg p-6 text-center min-w-xs max-w-sm">
      <p id="activity-check-title" class="text-lg font-bold mb-4">{{ $t('login.timeouttitle') }}</p>
      <p id="activity-check-desc" class="mb-4">{{ $t('login.timeouttxt') }}</p>
      <div class="w-full h-2 bg-slate-300 rounded overflow-hidden">
        <div
          class="h-full bg-skin-active128 rounded"
          :style="progressBarStyle"
        ></div>
      </div>
      <button @click="resetTimer" class="mt-6 w-full px-2 py-1 h-8 text-sm
          lg:px-4 lg:py-2 lg:h-12 lg:text-lg
          rounded-lg border-2 border-transparent
          font-semibold text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out">{{ $t('login.stayloggedin') }}</button>
    </div>
  </div>
  <router-view>
  </router-view>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      inactivityTimeout: this.$store.state.Timeout,
      showpopuptimer: 1 * 60 * 1000, // 1 Minute
      width: 100,
      inactivityTimer: null,
      showPopup: false,
    };
  },
  computed: {
    progressBarStyle() {
      return {
        width: `${this.width}%`,
        transition: `width ${this.showpopuptimer / 1000}s linear`,
      };
    },
  },
  methods: {
  async logoutUser() {
    try {
      const response = await axios.get(
        `wallbox/login.php?action=logout&user=${this.$store.state.token}`
      );
      if (response.data.status === "ok") {
        this.$router.push({ path: "/" });
        this.showPopup = false;
      } else {
        console.error("Logout failed: ", response.data.message || "Unknown error");
        this.$router.push({ path: "/" });
        this.showPopup = false;
      }
    } catch (error) {
      console.error("Network error during logout: ", error);
      // Optionally, provide user feedback here
    }
  },
  startProgressBarAnimation() {
    this.width = 100; // Reset to full width
    setTimeout(() => {
      this.width = 0; // Start animation
    }, 100);
  },
  startInactivityTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(() => {
      if (this.$router.currentRoute.value.path !== "/") {
        this.showPopup = true;
        this.startProgressBarAnimation();
        setTimeout(() => {
          if (this.showPopup) {
            this.logoutUser();
          }
        }, this.showpopuptimer);
      }
    }, this.inactivityTimeout);
  },
  resetTimer() {
    clearTimeout(this.inactivityTimer);
    this.showPopup = false;
    this.startInactivityTimer();
  },
  onActivity() {
    this.resetTimer();
  },
  addActivityListeners() {
    window.addEventListener("click", this.onActivity);
    window.addEventListener("keydown", this.onActivity);
  },
  removeActivityListeners() {
    window.removeEventListener("click", this.onActivity);
    window.removeEventListener("keydown", this.onActivity);
  },
},
mounted() {
  this.addActivityListeners();
  this.startInactivityTimer();
},
beforeUnmount() {
  this.removeActivityListeners();
  clearTimeout(this.inactivityTimer);
},

};
</script>

<style scoped></style>
